import axios from 'axios';
import { ERROR_CODES } from 'vio-constants';

import store from '../store';

import { setUnauthorized } from './slice';

export function setAxiosResponseInterceptors(): void {
	const { dispatch } = store;
	const responseInterceptor = axios.interceptors.response;

	responseInterceptor.use((response) => {
		return response;
	}, (error) => {
		const { response = {} } = error;
		const { status = 0 } = response;

		if (status === ERROR_CODES.UNAUTHORIZED) {
			dispatch(setUnauthorized());
		}

		return Promise.reject(error);
	});
}
